import Image from 'next/image';
import styled from 'styled-components';
import Layout from '@/components/Layout';
import Link from 'next/link';
import { useContext } from 'react';
import { DarkModeContext } from '@/pages/_app';

const Quote = styled.h2`
  margin-top: 0.5rem;
  line-height: 1.15;
  font-size: 1.5rem;
  font-weight: lighter;
`;

const IconContainer = styled.div`
  height: 1.5rem;
`;

const NevilleText = styled.p`
  text-align: center;
  padding: 0 2rem;
`;

const IconLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NevilleImageContainer = styled.div`
  width: '7.5rem';
  height: '12.5rem';
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NavRow = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const NavGroup = styled.div`
  border: black solid 0.125rem;
  border-radius: 0.5rem;
  padding: 1rem;
  margin: 1rem;
  flex: 1;
`;

const NavHeading = styled.div`
  background-color: #fafafa;
  padding: 0.5rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
`;

const NavHeadingText = styled.h2`
  font-size: 1.2rem;
  text-align: center;
`;

const NavButton = styled.div`
  border: 1px solid black;
  border-radius: 0.25rem;
  margin: 0.25rem;
  cursor: pointer;
  :hover {
    background-color: ${(props) => props.theme.colours.hover};
  }
`;

const NavH3 = styled.h3`
  font-size: 1.1rem;
  padding: 0;
  margin: 0.5rem;
  text-align: center;
`;

const Iframe = styled.iframe`
  border: 0;
  @media (max-width: 600px) {
    width: 320px;
    height: 180px;
  }
`;

const IframeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function Home() {
  const { darkMode } = useContext(DarkModeContext);
  function titleBackground() {
    return darkMode === 'light'
      ? { backgroundColor: 'white' }
      : { backgroundColor: '#bebdbd' };
  }
  return (
    <Layout
      title={"Neville Goddard's teachings"}
      description={'The complete teachings of Neville Goddard'}
    >
      <h1>Neville Goddard&apos;s teachings</h1>
      <NevilleImageContainer>
        <Image
          priority
          src="/images/neville-goddard.jpg"
          alt="Neville Goddard"
          width={132.5}
          height={199}
        />
      </NevilleImageContainer>
      <Quote>&quot;Imagination Creates Reality&quot;</Quote>
      {/* <Link
        target="_blank"
        rel="noreferrer"
        href="https://t.me/neville_goddard_discussions"
      >
        <IconLink>
          <p className="underline pointer">
            Join our Telegram discussion group
          </p>
          <IconContainer>
            &nbsp;
            <Image
              src="/images/telegram.png"
              width="30"
              height="30"
              alt="Telegram"
            />
          </IconContainer>
        </IconLink>
      </Link> */}
      {/* <IframeContainer>
        <Iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/hiwBSJr0F0U"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        />
      </IframeContainer> */}
      <NevilleText>
        <br />
        Neville Goddard was a philosopher and spiritual teacher who believed
        that the power of our thoughts and imagination could shape our reality.
      </NevilleText>
      <NevilleText>
        Learn from his collection of written works on how to manifest anything
        in your life. His teachings are broken down into key concepts and
        themes, with additional notes from other prominent teachers. Learn how
        to apply the teachings in your own life.
      </NevilleText>
      <NavRow>
        <NavGroup>
          <NavHeading style={titleBackground()}>
            <NavHeadingText>TOPICS</NavHeadingText>
          </NavHeading>
          <Link href="/neville-goddard/health">
            <NavButton>
              <NavH3>Health</NavH3>
            </NavButton>
          </Link>
          <Link href="/neville-goddard/wealth">
            <NavButton>
              <NavH3>Wealth</NavH3>
            </NavButton>
          </Link>
          <Link href="/neville-goddard/career">
            <NavButton>
              <NavH3>Career</NavH3>
            </NavButton>
          </Link>
          <Link href="/neville-goddard/relationships">
            <NavButton>
              <NavH3>Relationships</NavH3>
            </NavButton>
          </Link>
          <Link href="/neville-goddard/gratitude">
            <NavButton>
              <NavH3>Gratitude</NavH3>
            </NavButton>
          </Link>
          <Link href="/neville-goddard/double-mindedness">
            <NavButton>
              <NavH3>Double-mindedness</NavH3>
            </NavButton>
          </Link>
          <Link href="/neville-goddard/success">
            <NavButton>
              <NavH3>Success</NavH3>
            </NavButton>
          </Link>
        </NavGroup>
        <NavGroup>
          <NavHeading style={titleBackground()}>
            <NavHeadingText>CONCEPTS</NavHeadingText>
          </NavHeading>
          <Link href="/neville-goddard/revision">
            <NavButton>
              <NavH3>Revision</NavH3>
            </NavButton>
          </Link>
          <Link href="/neville-goddard/manifesting">
            <NavButton>
              <NavH3>Manifesting</NavH3>
            </NavButton>
          </Link>
          <Link href="/neville-goddard/state-akin-to-sleep">
            <NavButton>
              <NavH3>State akin to sleep (SATS)</NavH3>
            </NavButton>
          </Link>
          <br />
          <NavHeading style={titleBackground()}>
            <NavHeadingText>Q&A</NavHeadingText>
          </NavHeading>
          <Link href="/neville-goddard/five-lessons">
            <NavButton>
              <NavH3>Five Lessons</NavH3>
            </NavButton>
          </Link>
        </NavGroup>
        <NavGroup>
          <NavHeading style={titleBackground()}>
            <NavHeadingText>GUIDES</NavHeadingText>
          </NavHeading>
          <Link href="/manifesting-guides/how-to-manifest-a-car">
            <NavButton>
              <NavH3>Manifest a car</NavH3>
            </NavButton>
          </Link>
          <Link href="/manifesting-guides/how-to-manifest-a-job">
            <NavButton>
              <NavH3>Manifest a job</NavH3>
            </NavButton>
          </Link>
          <br />
          <NavHeading style={titleBackground()}>
            <NavHeadingText>SUCCESS STORIES</NavHeadingText>
          </NavHeading>
          <Link href="/manifesting-guides/success-stories">
            <NavButton>
              <NavH3>Stories</NavH3>
            </NavButton>
          </Link>
        </NavGroup>
      </NavRow>
      <NavRow>
        <NavGroup>
          <NavHeading style={titleBackground()}>
            <NavHeadingText>JOSEPH MURPHY</NavHeadingText>
          </NavHeading>
          <Link href="/joseph-murphy/the-power-of-the-subconscious-mind">
            <NavButton>
              <NavH3>The power of the subconscious mind</NavH3>
            </NavButton>
          </Link>
          <Link href="/joseph-murphy/mental-healing-techniques">
            <NavButton>
              <NavH3>Mental healing techniques</NavH3>
            </NavButton>
          </Link>
        </NavGroup>
        {/* <NavGroup>
          <NavHeading style={titleBackground()}>
            <NavHeadingText>TOOLS</NavHeadingText>
          </NavHeading>
          <Link href="/manifesting-guides/affirmation-creator-tool">
            <NavButton>
              <NavH3>
                Affirmation creator
                <span>
                  <em>
                    <span style={{ color: '#c300c0' }}> new! </span>
                  </em>
                </span>
              </NavH3>
            </NavButton>
          </Link>
        </NavGroup> */}
        <NavGroup>
          <NavHeading style={titleBackground()}>
            <NavHeadingText>JAMES NEWMAN</NavHeadingText>
          </NavHeading>
          <Link href="/james-newman/creating-affirmations">
            <NavButton>
              <NavH3>Creating Affirmations</NavH3>
            </NavButton>
          </Link>
        </NavGroup>
      </NavRow>
    </Layout>
  );
}
